import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Flex, Typography } from 'antd';

import Header from '../../components/Header/Header';
import { validateInput, validateCaptcha } from '../../api/validation';

import {
  FormattedMessage,
  defineMessages,
  intlShape,
  injectIntl,
} from 'react-intl';

import { getToggleLanguage } from '../../api/shareVariable';
import { configuration } from '../../configuration';
import '../../index.css';

//Modal
import Modal from 'react-modal';
import '../../assets/stylesheet/modal.css';

//Action
import {
  setLanguage,
  checkOTP,
  requestOTP,
  genCaptcha,
  checkCaptchaRequestOTP,
  checkCaptchaSendOTP,
  setCaptchaStatus,
} from '../../actions/user';

//images
import imageSrcOTPEMAIL from '../../assets/images/OTP-EMAIL.png';
import imageSrcRefresh from '../../assets/images/reload-captcha.png';

let counter = 0;

const { Text } = Typography

class OTP extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      modalIsOpen: false,
      switchMode: 'Email',
      waiting: true,
      captcha_show: false,
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.onOTPRequest = this.onOTPRequest.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.onReCaptcha = this.onReCaptcha.bind(this);
  }

  UNSAFE_componentWillMount() {
    // let { user ,language} = this.props
    let { callback, system, id, captcha_status } = this.props.user;

    if (id === '' || this.props.history.action === 'POP') {
      this.props.history.push(
        '/?e=timeout&c=' + callback + '&s=' + system + '&d=' + id,
      );
    }

    let url = this.getJsonFromUrl();
    if (url) {
      if (url.e === 'captcharequest') {
        this.setState({ errorFlag: 'OTP' });
        //genCaptcha
        this.props.genCaptcha().then(captcha_ref => {
          counter++;
          this.setState({
            captchaURL: `${
              configuration.webServiceEndpoint[configuration.mode]
            }/get-captcha?captchaId=${captcha_ref}&cache=${counter}`,
          });
          this.openModal();
        });
      } else if (url.e === 'exceed') {
        this.setState({
          errorFlag: 'error',
          error: this.getTextFromDic('sms_error'),
          modalIsOpen: true,
          waiting: false,
        });
      } else if (url.e === 'smserror') {
        this.setState({
          errorFlag: 'error',
          error: this.getTextFromDic('sms_error'),
          modalIsOpen: true,
          waiting: false,
        });
      } else if (url.e === 'emailerror') {
        this.setState({
          errorFlag: 'error',
          error: this.getTextFromDic('sms_error'),
          modalIsOpen: true,
          waiting: false,
        });
      }
    }
    if (captcha_status === 'CaptchaCheck') {
      this.onReCaptcha();
      this.setState({ captcha_show: true });
    }
  }

  getTextFromDic(msg) {
    const { formatMessage } = this.props.intl;

    return formatMessage(defineMessages({ message: { id: msg } }).message);
  }

  getJsonFromUrl() {
    var result = [];
    let link_page = window.location.href;
    link_page.split('&').forEach(function (part) {
      var item = part.split('=');
      if (item[0].includes('?')) {
        let temp = item[0].split('?');
        item[0] = temp[1];
        // item[0] =
      }
      result[item[0]] = decodeURIComponent(item[1]);
    });
    return result;
  }

  setLanguage() {
    const { user } = this.props;
    let langTemp = user.language;
    let newLang = '';
    if (langTemp === 'th') newLang = 'en';
    else newLang = 'th';
    // dispatch(setLanguage(newLang))
    this.props.setLanguage(newLang);
  }

  openModal() {
    this.setState({ modalIsOpen: true });
  }

  closeModal() {
    this.setState({ captcha_wrongInput: '' });
    this.setState({ captcha: '' });
    this.setState({ modalIsOpen: false });
  }

  validate(evt) {
    var theEvent = evt || window.event;
    var key = theEvent.keyCode || theEvent.which;
    key = String.fromCharCode(key);
    var regex = /[0-9]/;
    if (!regex.test(key)) {
      theEvent.returnValue = false;
      if (theEvent.preventDefault) theEvent.preventDefault();
    }
  }

  onSubmit(e) {
    e.preventDefault();
    let { otpREF, id, captcha_status } = this.props.user;
    let { OTP } = this.state;
    let checker = validateInput(OTP);

    if (checker === true) {
      this.setState({ submiting: true });
      //reCaptcha before 5 times

      if (captcha_status === 'CaptchaCheck') {
        //Wrong Input more than 5
        if (this.state.captcha_wrongInput === '') {
          //logControl(id,command ,`${loglist[command]} - Wrong Input more than 5 times`,0)
          this.setState({ waiting: false });
          this.setState({ errorFlag: 'blank' });
          this.setState({ error: this.getTextFromDic('app.otp.errorblank') });
          this.setState({ modalIsOpen: true });
        } else {
          this.onOTPWrongInput_WithCaptcha(e);
        }
      } else {
        //Normal
        //username, ref , sec1
        let result = this.props.checkOTP(id, otpREF, OTP);
        this.setState({ waiting: false });
        result.then(response => {
          this.setState({ submiting: false });
          this.setState({ OTP: '' });
          //for skipping in localhost
          //response.data = {status : "success"}
          if (response.data.status === 'error') {
            if (
              response.data.messageCode === 'OTP001' ||
              response.data.messageCode === 'OTP003'
            ) {
              // OTP Not Match with Reference number
              //logControl(id,command ,`${loglist[command]} - OTP not match`,0)
              this.setState({ errorFlag: 'error' });
              this.setState({
                error: this.getTextFromDic('app.otp.error_password'),
              });
              this.setState({ modalIsOpen: true });
            } else if (response.data.messageCode === 'OTP002') {
              // OTP is Expired.
              //logControl(id,command ,`${loglist[command]} - '+'OTP expired`,0)
              this.setState({ errorFlag: 'error' });
              this.setState({
                error: this.getTextFromDic('app.otp.error_otp_expired'),
              });
              this.setState({ modalIsOpen: true });

              this.onOTPRequest();
            } else if (response.data.messageCode === 'CAPT001') {
              //logControl(id,command ,`${loglist[command]} - Captcha incorrect`,0)
              let status = 'CaptchaCheck';
              this.props.setCaptchaStatus(status);
              this.onReCaptcha();
              this.setState({ captcha_show: true });
            } else if (response.data.messageCode === 'CAPT002') {
              //logControl(id,command ,`${loglist[command]} - OTP not match with Captcha`,0)
              let status = 'CaptchaCheck';
              this.props.setCaptchaStatus(status);
              this.onReCaptcha();
              this.setState({ captcha_show: true });
            } else if (response.data.messageCode === 'CAPT003') {
              //logControl(id,command ,`${loglist[command]} - OTP not match with Captcha`,0)
              let status = 'CaptchaCheck';
              this.props.setCaptchaStatus(status);
              this.onReCaptcha();
              this.setState({ captcha_show: true });
            } else {
              //Exception Error
              console.log('Exception error');
              this.setState({ errorFlag: 'error' });
              this.setState({
                error: this.getTextFromDic('app.otp.catch_error'),
              });
              this.setState({ modalIsOpen: true });
            }
          } else if (response.data.status === 'success') {
            //logControl(id,command ,loglist[command],1)
            //success then redirect
            window.location = `${configuration.callback[configuration.mode]}`;
          } else {
            //Exception Error
            console.log('Exception error');
            this.setState({ errorFlag: 'error' });
            this.setState({
              error: this.getTextFromDic('app.otp.catch_error'),
            });
            this.setState({ modalIsOpen: true });
          }
        });
      }
      this.setState({ submiting: false });
    } else if (checker === 'blank') {
      //logControl(id,command ,`${loglist[command]} - input blank`,0)

      this.setState({ waiting: false });
      this.setState({ errorFlag: 'blank' });
      this.setState({ error: this.getTextFromDic('app.otp.errorblank') });
      this.setState({ modalIsOpen: true });
    }

    this.setState({ captcha_wrongInput: '', captcha: '' });
  }

  onReCaptcha() {
    let { id } = this.props.user;

    let result = this.props.genCaptcha(id);
    result.then(captcha_ref => {
      counter++;
      this.setState({
        captchaURL: `${
          configuration.webServiceEndpoint[configuration.mode]
        }/get-captcha?captchaId=${captcha_ref}&cache=${counter}`,
      });
    });
  }

  onOTPRequest() {
    // e.preventDefault();
    let { id } = this.props.user;

    //let command = getCommand('RECEIVED_OTP',CWPuser)
    this.setState({ waiting: true });
    let result = this.props.requestOTP(id, this.props.user.email);
    this.waitingModal();

    result.then(response => {
      this.setState({ waiting: false });
      // if(response.status === "CaptchaRequest") {
      //   //logControl(id,command ,`${loglist[command]} - OTP mare than 5 times`,0)
      //   this.setState({errorFlag : "OTP"})
      //   this.openModal()
      //   //genCaptcha
      //   this.props.genCaptcha().then((captcha_ref) => {
      //     counter++;
      //     this.setState({ captchaURL : `${configuration.webServiceEndpoint[configuration.mode]}/get-captcha?captchaId=${captcha_ref}&cache=${counter}`})
      //     this.setState({ modalIsOpen : true})
      // })
      // }
      // else if(response.status === "error") {
      if (response.status === 'error') {
        if (response.code === 'CAPT003') {
          //Exceed to request then required Captcha
          //logControl(id,command ,`${loglist[command]} - OTP mare than 5 times`,0)
          // this.setState({ captchaError : this.getTextFromDic('app.otp.captcha_exceed')})
          this.setState({ errorFlag: 'OTP' });
          this.openModal();
          //genCaptcha
          this.props.genCaptcha().then(captcha_ref => {
            counter++;
            this.setState({
              captchaURL: `${
                configuration.webServiceEndpoint[configuration.mode]
              }/get-captcha?captchaId=${captcha_ref}&cache=${counter}`,
            });
            this.setState({ modalIsOpen: true });
          });
        } else if (response.code === 'EMAIL001') {
          //Email Error (Backend)
          //logControl(id,command ,`${loglist[command]} - Email Error (Backend)`,0)
          this.setState({
            captchaError: this.getTextFromDic('app.otp.email_error'),
          });
        }
      } else if (response.status === 'success') {
        //logControl(id,command ,loglist[command],1)
        this.setState({ captcha_show: false });
        this.setState({ waiting: false });
        this.closeModal();
      } else {
        //logControl(id,command ,`${loglist[command]} - Exception Error`,0)
        this.setState({ waiting: false });
        this.closeModal();
      }
    });

    this.setState({ OTP: '' });
  }

  //Waiting Text
  waitingModal() {
    this.setState({ waiting: true });
    this.setState({ errorFlag: 'waiting' });
    this.setState({ error: this.getTextFromDic('app.otp.waiting') });
    this.openModal();
  }

  onOTPRequest_WithCaptcha(e) {
    let { id, captcha_ref } = this.props.user;
    let { captcha } = this.state;

    //let command = getCommand('RESEND_OTP_MORE_5_TIME',CWPuser)
    this.setState({ captcha: '' });

    let checker = validateCaptcha(captcha);
    if (checker !== true) {
      let temp =
        checker === 'blank'
          ? this.getTextFromDic('app.otp.catpcha_blank')
          : this.getTextFromDic('app.otp.catpcha_notmatch');
      this.setState({ captchaError: temp });
    } else {
      //username,inputCaptcha,ref_captcha
      let result = this.props.checkCaptchaRequestOTP(
        id,
        captcha,
        captcha_ref,
        this.props.user.email,
      );
      result.then(response => {
        if (response.status === 'success') {
          //logControl(id,command ,loglist[command],1)
          this.setState({ captcha_show: false });
          this.closeModal();
        } else if (response.status === 'error') {
          //migration for current Captcha not refresh everytime
          this.onReCaptcha(e);
          if (['CAPT001','CAPT002'].includes(response.code)) {
            //logControl(id,command ,`${loglist[command]} - Captcha error`,0)
            this.setState({
              captchaError: this.getTextFromDic('app.otp.captcha_error'),
            });
          } else if (response.code === 'EMAIL001') {
            //logControl(id,command ,`${loglist[command]} - Email error`,0)
            this.setState({
              captchaError: this.getTextFromDic('app.otp.email_error'),
            });
          } else {
            //logControl(id,command ,`${loglist[command]}- Exception error`,0)
            this.setState({
              captchaError: this.getTextFromDic('app.otp.catch_error'),
            });
          }
        } else {
          //Exception error
          //logControl(id,command ,`${loglist[command]} - Exception error`,0)
          this.setState({
            captchaError: this.getTextFromDic('app.otp.catch_error'),
          });
        }
      });
    }
  }

  onOTPWrongInput_WithCaptcha(e) {
    let { otpREF, id, captcha_ref } = this.props.user;
    let { captcha_wrongInput, OTP } = this.state;
    this.setState({ captcha_wrongInput: '' });
    this.setState({ captcha: '' });

    //validate
    let checker = validateCaptcha(captcha_wrongInput);
    if (checker !== true) {
      //validate not pass
      let temp =
        checker === 'blank'
          ? this.getTextFromDic('app.otp.catpcha_blank')
          : this.getTextFromDic('app.otp.catpcha_notmatch');

      this.setState({ errorFlag: 'waiting' });
      this.setState({ error: temp });
      this.openModal();
      this.setState({ submiting: false });
    } else {
      //username,inputCaptcha,ref_captcha,ref,sec1
      let result = this.props.checkCaptchaSendOTP(
        id,
        captcha_wrongInput,
        captcha_ref,
        otpREF,
        OTP,
      );
      //inputCaptcha, OTPRef , OTP, mobileNumber , otpChannel, id ,captcha_ref,pageAction
      result.then(response => {
        this.setState({ submiting: false });

        if (response.status === 'success') {
          window.location = `${configuration.callback[configuration.mode]}`;
        } else if (response.status === 'error') {
          if (response.code === 'OTP001') {
            //OTP Incorrect

            //migration for current Captcha not refresh everytime
            this.onReCaptcha(e);
            this.setState({ errorFlag: 'blank' });
            this.setState({
              error: this.getTextFromDic('app.otp.error_password'),
            });
            this.openModal();
          }
          if (response.code === 'OTP002') {
            //OTP expired

            //migration for current Captcha not refresh everytime
            this.onReCaptcha(e);
            this.setState({ errorFlag: 'blank' });
            this.setState({
              error: this.getTextFromDic('app.otp.error_otp_expired'),
            });
            this.openModal();
          } else if (response.code === 'CAPT001') {
            //captcha error

            //migration for current Captcha not refresh everytime
            this.onReCaptcha(e);
            this.setState({ errorFlag: 'blank' });
            this.setState({
              error: this.getTextFromDic('app.otp.error_captcha'),
            });
            this.openModal();
          } else if (response.code === 'CAPT002') {
            //migration for current Captcha not refresh everytime
            this.onReCaptcha(e);
            this.setState({ errorFlag: 'blank' });
            this.setState({ error: this.getTextFromDic('app.otp.both_error') });
            this.openModal();
          }
        } else {
          //migration for current Captcha not refresh everytime
          this.onReCaptcha(e);
          this.setState({ errorFlag: 'blank' });
          this.setState({ error: this.getTextFromDic('app.otp.catch_error') });
          this.openModal();
        }
      });
    }
  }

  render() {
    const { language, email, otpREF, OTP } = this.props.user;
    // const { formatMessage } = this.props.intl;

    return (
      <div>
        <Header
          next={
            <Button
              className="languageSwicher"
              onClick={() => this.setLanguage()}
            >
              {' '}
              {getToggleLanguage(language)}{' '}
            </Button>
          }
        />
        <Flex justify={'center'} align={'center'}>
          <div className='box'>
            <form className="form-signin" onSubmit={this.onSubmit}>
              <div className="col-md-12 mb-15 text-center img-margin">
                <img
                  alt="OTP"
                  src={imageSrcOTPEMAIL}
                  width="149px"
                  className="img-responsive"
                />
              </div>
              <div className="col-md-6 offset-md-3 title">
                <FormattedMessage id="app.otp.title" />
              </div>
              <div className="col-md-6 offset-md-3 mb-30 subtitle">
                <FormattedMessage id="app.otp.subtitle" />
                <FormattedMessage id="app.otp.subtitle1" />
                <FormattedMessage id="app.otp.email" />
                {email}
                <FormattedMessage id="app.otp.subtitle2" />
              </div>

              <div className="col-md-6 offset-md-3 text-only">
                <input
                  type="tel"
                  onKeyPress={event => this.validate(event)}
                  maxLength="6"
                  style={{ textAlign: 'center' }}
                  className="form-control form-big"
                  value={this.state.OTP}
                  onChange={event => this.setState({ OTP: event.target.value })}
                />
              </div>
              <div className="row col-md-6 offset-md-3 mb-30 text-center text-only">
                <div className="col-6 text-left">
                  <FormattedMessage id="app.otp.ref" />: {otpREF}
                </div>
                <div className="col-6 red text-right">
                  <Text className="link" onClick={this.onOTPRequest}>
                    <FormattedMessage id="app.otp.resend" />
                  </Text>
                </div>
              </div>
              {this.state.captcha_show && (
                <div className="row col-md-6 offset-md-3 mb-30 text-only">
                  <div className="col-6">
                    <img
                      className="captchaImage"
                      alt="Captcha"
                      src={this.state.captchaURL}
                    />
                    <Text
                      onClick={e => {
                        //let command = getCommand('REFRESH_CAPTCHA',CWPuser)
                        //logControl(id,command ,loglist[command],1)
                        this.setState({ captcha_wrongInput: '' });

                        this.onReCaptcha(e);
                      }}
                      className="resendcaptchaButton link"
                    >
                      <img
                        src={imageSrcRefresh}
                        alt=""
                        width="20px"
                        className=""
                      />
                    </Text>
                  </div>
                  <div className="col-6">
                    <input
                      type="text"
                      maxLength="7"
                      className="form-control form-big"
                      value={this.state.captcha_wrongInput}
                      onChange={event =>
                        this.setState({ captcha_wrongInput: event.target.value })
                      }
                    />
                  </div>
                </div>
              )}

              <div className="col-md-6 offset-md-3 text-center text-only">
                {configuration.mode !== 'prod' && (
                  <span> (Mock up OTP:{OTP}) </span>
                )}
                {/* <input
                  className="btn btn-pru btn-block submit bigButton"
                  type="submit"
                  value={formatMessage(
                    defineMessages({ message: { id: 'app.otp.next' } }).message,
                  )}
                  disabled={this.state.submiting}
                /> */}
                <Button shape="round" className='bigButton' type='primary' danger disabled={this.state.submiting} loading={this.state.submiting} htmlType={'submit'}><FormattedMessage id="app.home.next" /></Button>
              </div>
            </form>
          </div>
        </Flex>

        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          className="reactModal"
          contentLabel="Modal View"
        >
          {this.state.errorFlag !== 'blank' &&
            this.state.errorFlag !== 'waiting' &&
            this.state.errorFlag !== 'error' && (
            <div className="contrainer">
              <div className="row mb-15">
                <div
                  className="col-12 text-only"
                  style={{ textAlign: 'center' }}
                >
                    คุณได้ขอรับรหัสผ่านแบบใช้ครั้งเดียว OTP
                    มากเกินกว่าที่ระบบกำหนด กรุณายืนยันตัวตนด้วยรูปภาพ
                </div>
                <span className="col-12" style={{ color: 'red' }}>
                  {' '}
                  {this.state.captchaError}
                </span>
              </div>
              <div className="row mb-30">
                <div className="col-6 text-only">
                  <img
                    className="captchaImage"
                    alt="Captcha"
                    src={this.state.captchaURL}
                  />
                  <Text
                    onClick={e => {
                      // let command = getCommand('REFRESH_OTP_MORE_5_TIME',CWPuser)
                      //logControl(id,command ,loglist[command],1)
                      this.setState({ captchaError: '' });
                      this.setState({ captcha: '' });
                      this.onReCaptcha(e);
                    }}
                    className="resendcaptchaButton link"
                  >
                    <img
                      src={imageSrcRefresh}
                      alt=""
                      width="20px"
                      className=""
                    />
                  </Text>
                </div>
                <div className="col-6 text-only">
                  <input
                    type="text"
                    maxLength="7"
                    className="form-control form-big"
                    value={this.state.captcha}
                    onChange={event =>
                      this.setState({ captcha: event.target.value })
                    }
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-12 text-only">
                  <input
                    className="btn btn-pru btn-block submit bigButton"
                    onClick={event => this.onOTPRequest_WithCaptcha(event)}
                    type="button"
                    value={this.getTextFromDic('app.otp.resendcaptcha')}
                    disabled={false}
                  />
                </div>
              </div>
            </div>
          )}

          {(this.state.errorFlag === 'blank' ||
            this.state.errorFlag === 'waiting' ||
            this.state.errorFlag === 'error') && (
            <div className="contrainer">
              <div className="row mb-15">
                <div
                  className="col-12 text-only"
                  style={{ textAlign: 'center' }}
                >
                  {this.state.error}
                </div>
              </div>
            </div>
          )}
        </Modal>
      </div>
    );
  }
}

OTP.propTypes = {
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const { user } = state;

  return {
    user,
  };
};
//captcha , mobileNumber , channel ,id ,captcha_ref ,pageAction,phone,phoneRef
const mapDispatchToProps = dispatch => {
  return {
    checkOTP: (id, otpREF, OTP) => dispatch(checkOTP(id, otpREF, OTP)),
    requestOTP: (...args) => dispatch(requestOTP(...args)),
    checkCaptchaRequestOTP: (...args) =>
      dispatch(checkCaptchaRequestOTP(...args)),
    checkCaptchaSendOTP: (username, inputCaptcha, ref_captcha, ref, sec1) =>
      dispatch(
        checkCaptchaSendOTP(username, inputCaptcha, ref_captcha, ref, sec1),
      ),
    genCaptcha: id => dispatch(genCaptcha(id)),
    setLanguage: newLang => dispatch(setLanguage(newLang)),
    setCaptchaStatus: status => dispatch(setCaptchaStatus(status)),
  };
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(OTP));
